module.exports = __webpack_public_path__ + "static/img/banner5.9c1050c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/banner5.jpg
// module id = fwUT
// module chunks = 1